import { render, staticRenderFns } from "./ProductFeaturesBanner.vue?vue&type=template&id=0c4203b0"
import script from "./ProductFeaturesBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductFeaturesBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSectionTitle: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/ui/UiSectionTitle.vue').default,UiVideo: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/ui/UiVideo.vue').default})
